/* Printora — sitewide snowfall. Single fixed canvas, pointer-events none, a few dozen soft flakes
   with depth (size / speed / blur), gentle drift. Pauses when the tab is hidden, stops when the
   canvas is scrolled off... it never is (fixed), so it throttles instead on low-power hints.
   Honours prefers-reduced-motion and a customer toggle stored in localStorage. */
(function () {
  'use strict';
  if (window.__pv27Snow) return;
  const KEY = 'pv27-snow';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;
  if (document.querySelector('.pgb-app, [data-gsb-app], .gang-sheet-builder')) return; // keep the builder canvas fast

  const body = document.body;
  const canvas = document.createElement('canvas');
  canvas.className = 'pv27-snow';
  canvas.setAttribute('aria-hidden', 'true');
  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) return;

  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'pv27-snow-toggle';
  toggle.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 2v20M4.9 6.5l14.2 11M19.1 6.5l-14.2 11M12 2l-2.2 2.2M12 2l2.2 2.2M12 22l-2.2-2.2M12 22l2.2-2.2M4.9 6.5l.6 3M4.9 6.5l3-.6M19.1 17.5l-.6-3M19.1 17.5l-3 .6M19.1 6.5l-.6 3M19.1 6.5l-3-.6M4.9 17.5l.6-3M4.9 17.5l3 .6"/></svg>';

  let enabled = localStorage.getItem(KEY) !== 'off';
  let flakes = [];
  let width = 0, height = 0, dpr = 1, raf = 0, last = 0, running = false;
  const mobile = window.matchMedia('(max-width: 749px)');

  function setLabel() {
    toggle.setAttribute('aria-label', enabled ? 'Turn snow off' : 'Turn snow on');
    toggle.title = enabled ? 'Turn snow off' : 'Turn snow on';
    toggle.classList.toggle('is-off', !enabled);
  }

  function makeFlake(fromTop) {
    const depth = Math.random();                 // 0 = far, 1 = near
    return {
      x: Math.random() * width,
      y: fromTop ? -10 : Math.random() * height,
      r: 0.9 + depth * 2.4,
      vy: 18 + depth * 42,                       // px per second
      drift: (Math.random() - 0.5) * 14,
      phase: Math.random() * Math.PI * 2,
      sway: 0.4 + Math.random() * 0.8,
      alpha: 0.35 + depth * 0.55,
      depth
    };
  }

  function resize() {
    width = window.innerWidth;
    height = window.innerHeight;
    dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const target = Math.min(mobile.matches ? 45 : 95, Math.round((width * height) / (mobile.matches ? 9000 : 16000)));
    while (flakes.length < target) flakes.push(makeFlake(false));
    if (flakes.length > target) flakes.length = target;
  }

  function frame(now) {
    if (!running) return;
    const dt = Math.min(0.05, (now - (last || now)) / 1000);
    last = now;
    ctx.clearRect(0, 0, width, height);
    for (const f of flakes) {
      f.phase += dt * f.sway;
      f.y += f.vy * dt;
      f.x += (f.drift + Math.sin(f.phase) * 12) * dt;
      if (f.y > height + 8) { Object.assign(f, makeFlake(true)); }
      if (f.x < -8) f.x = width + 8; else if (f.x > width + 8) f.x = -8;
      // soft flake: light core with a cool halo so it reads on both white and dark backgrounds
      const g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r * 2.2);
      g.addColorStop(0, 'rgba(255,255,255,' + f.alpha + ')');
      g.addColorStop(0.55, 'rgba(226,236,246,' + (f.alpha * 0.55) + ')');
      g.addColorStop(1, 'rgba(200,216,232,0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(f.x, f.y, f.r * 2.2, 0, Math.PI * 2);
      ctx.fill();
    }
    raf = requestAnimationFrame(frame);
  }

  function start() {
    if (running || !enabled || document.hidden) return;
    running = true; last = 0;
    canvas.hidden = false;
    raf = requestAnimationFrame(frame);
  }
  function stop(clear) {
    running = false;
    if (raf) cancelAnimationFrame(raf);
    raf = 0;
    if (clear) { ctx.clearRect(0, 0, width, height); canvas.hidden = true; }
  }

  toggle.addEventListener('click', () => {
    enabled = !enabled;
    localStorage.setItem(KEY, enabled ? 'on' : 'off');
    setLabel();
    if (enabled) { resize(); start(); } else stop(true);
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(false); else start(); });
  window.addEventListener('resize', () => { resize(); }, { passive: true });
  reduce.addEventListener('change', () => { if (reduce.matches) stop(true); else start(); });

  body.appendChild(canvas);
  body.appendChild(toggle);
  setLabel();
  resize();
  if (enabled) start(); else canvas.hidden = true;
  window.__pv27Snow = { start, stop };
})();
